<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    {{ dockReservationTitle }}
                </h1>
                <v-spacer />
                <v-btn
                    v-if="!isUpdateClipboardReservationAction && canMoveToClipboard && !isNotificationGateHouseView"
                    color="warning"
                    small
                    text
                    data-sentry-label="W schowek"
                    :loading="actionLoading"
                    @click="toClipboard"
                >
                    Do schowka
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row v-if="!isCreateAction && !isUpdateClipboardReservationAction">
                    <v-col cols="12">
                        <v-select
                            v-model="dockReservation"
                            :items="dockReservations"
                            item-value="id"
                            return-object
                            outlined
                            dense
                            :disabled="isViewAction"
                            label="Rezerwacja"
                            @change="updateDate(dockReservation)"
                        >
                            <template slot="selection" slot-scope="data">
                                {{ setReservationDate(data.item.start, data.item.end, data) }} - {{ data.item.dock.name }}
                            </template>

                            <template slot="item" slot-scope="data">
                                {{ setReservationDate(data.item.start, data.item.end, data) }} - {{ data.item.dock.name }}
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-select
                            v-model="dockReservation.dockId"
                            :items="docks"
                            item-value="id"
                            item-text="name"
                            outlined
                            dense
                            :error-messages="selectedDockErrors"
                            :disabled="!isCreateAction"
                            label="Dostępne doki"
                            :clearable="!isUpdateDockReservationAction"
                            @change="clearDate()"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="isWarehouseUser || isGateUser">
                    <v-col cols="12">
                        <v-autocomplete
                            v-model="dockReservation.customerId"
                            :items="customers"
                            :filter="customFilter"
                            :loading="customersSearchLoading"
                            :search-input.sync="customersSearch"
                            class="v-text-field--placeholder-dark"
                            :error-messages="customerIdErrors"
                            :disabled="isUpdateDockReservationAction || isUpdateClipboardReservationAction || isViewAction || !dockReservation.dockId"
                            label="Klient"
                            required
                            outlined
                            dense
                            item-value="id"
                            no-data-text="Nie znaleziono"
                            :clearable="!isUpdateDockReservationAction"
                            @change="clearDate()"
                        >
                            <template slot="no-data">
                                <v-list-item>
                                    <v-list-item-title>
                                        <template v-if="!customersSearch">
                                            Wpisz treść aby odnaleźć <strong>klienta</strong>.
                                        </template>
                                        <template v-else-if="customersSearchLoading">
                                            Trwa wyszukiwanie...
                                        </template>
                                        <template v-else>
                                            Nie znaleziono
                                        </template>
                                    </v-list-item-title>
                                </v-list-item>
                            </template>
                            <template slot="selection" slot-scope="data">
                                {{ data.item.name }}
                            </template>

                            <template slot="item" slot-scope="data">
                                {{ data.item.name }}
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row v-if="isCreateAction">
                    <v-col cols="12" lg="6">
                        <v-menu
                            v-model="menuFrom"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            dense
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template #activator="{on}">
                                <v-text-field
                                    v-model="dockReservation.dockingStartDate"
                                    label="Wybierz datę rezerwacji"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    clearable
                                    dense
                                    outlined
                                    :error-messages="dockingStartDateErrors"
                                    :disabled="(isWarehouseUser && (!dockReservation.customerId || !dockReservation.dockId)) || !dockReservation.dockId"
                                    v-on="on"
                                />
                            </template>
                            <v-date-picker
                                v-model="dockReservation.dockingStartDate"
                                first-day-of-week="1"
                                @input="menuFrom = false"
                                @change="displayHours()"
                            />
                        </v-menu>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-select
                            v-model="dockReservation.dockingStartDateTime"
                            :items="availableHoursForSelectedDay"
                            item-value="start"
                            outlined
                            dense
                            :error-messages="dockingStartDateTimeErrors"
                            :disabled="!dockReservation.dockingStartDate"
                            label="Dostępne godziny"
                        >
                            <template slot="selection" slot-scope="data">
                                {{ setAvailableHours(data.item.start) }}
                            </template>

                            <template slot="item" slot-scope="data">
                                {{ setAvailableHours(data.item.start) }}
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" lg="6">
                        <v-text-field
                            v-model="dockReservation.firstName"
                            outlined
                            dense
                            :disabled="isViewAction"
                            label="Imię kierowcy"
                        />
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-text-field
                            v-model="dockReservation.lastName"
                            outlined
                            dense
                            :disabled="isViewAction"
                            label="Nazwisko kierowcy"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" lg="6">
                        <v-text-field
                            v-model="dockReservation.palletsQuantity"
                            v-mask="'##'"
                            outlined
                            dense
                            :disabled="isViewAction"
                            :error-messages="dockReservationPalletsQuantityErrors"
                            label="Ilość palet"
                        />
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-text-field
                            v-model="dockReservation.plateNumber"
                            v-mask="'XXXXXXXXXXXX'"
                            outlined
                            dense
                            :disabled="isViewAction"
                            :error-messages="carPlateNumberErrors"
                            label="Numer rejestracyjny auta"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" lg="6">
                        <v-text-field
                            v-model="dockReservation.trailerPlateNumber"
                            v-mask="'XXXXXXXXXXXX'"
                            outlined
                            dense
                            :disabled="isViewAction"
                            :error-messages="trailerPlateNumberErrors"
                            label="Numer rejestracyjny naczepy"
                        />
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-text-field
                            v-model="dockReservation.contactNumber"
                            v-mask="'+###########'"
                            outlined
                            dense
                            :disabled="isViewAction"
                            :error-messages="contactNumberErrors"
                            label="Numer telefonu kontaktowego"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    v-if="canEditNotification && isViewAction && !isNotificationGateHouseView"
                    text
                    color="success"
                    data-sentry-label="Edytuj"
                    @click="() => action = 'updateDockReservation'"
                >
                    Edytuj
                </v-btn>
                <v-btn
                    v-if="canEditNotification && !isViewAction"
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="saveNotification()"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import store from '@/store'

import filters from '@/mixins/customFilters'

import { hasUserPermission } from '@/utils/permissionsHandler'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'

import { required, integer, between, requiredIf, minLength } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { format } from 'date-fns'

let searchTimer

export default {
    name: 'NotificationDialog',
    directives: { mask },
    mixins: [
        filters,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        actionName: {
            type: String,
            default: null
        },
        dockReservationTitle: {
            type: String,
            default: null
        },
        currentDockReservation: {
            type: Object,
            default: null
        },
        componentName: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            action: null,
            customersSearch: null,
            customersSearchLoading: false,
            customers: [],
            dockReservation: {
                palletsQuantity: null,
                trailerPlateNumber: null,
                plateNumber: null,
                contactNumber: null,
                dockingStartDate: null,
                dockingStartDateTime: null,
                dockId: null,
                customerId: null,
                firstName: null,
                lastName: null,

            },
            pageTitle: '',
            menuFrom: false,
            menuTo: false,
            actionLoading: false,
            needToShowReservationSection: false,
        }
    },
    validations: {
        dockReservation: {
            palletsQuantity: {
                integer,
                required,
                between: between(0, 50),
            },
            trailerPlateNumber: {
                minLength: minLength(3),
            },
            plateNumber: {
                minLength: minLength(3),
                required
            },
            contactNumber: {
                minLength: minLength(12),
                required
            },
            dockId: {
                required
            },
            dockingStartDate: {
                required: requiredIf(function() {
                    return this.isCreateAction
                })
            },
            dockingStartDateTime: {
                required: requiredIf(function() {
                    return this.isCreateAction
                })
            },
            customerId: {
                required: requiredIf(function() {
                    return this.isWarehouseUser
                })
            },
        }
    },
    computed: {
        isWarehouseUser() {
            return hasUserPermission('notification_all_update') || hasUserPermission('notification_all_create')
        },
        isGateUser() {
            return hasUserPermission('notification_gate_user_read')
        },
        canEditNotification() {
            return hasUserPermission('notification_all_update') || hasUserPermission('notification_update')
        },
        canMoveToClipboard() {
            return !!this.dockReservation.id
        },
        isUpdateDockReservationAction() {
            return this.action === 'updateDockReservation'
        },
        isUpdateClipboardReservationAction() {
            return this.action === 'updateClipboardReservation'
        },
        isViewAction() {
            return this.action === 'openDockReservation'
        },
        isCreateAction() {
            return this.action === 'createDockReservation'
        },
        isMainViewNotificationGateHouse() {
            return this.componentName === 'NotificationGateHouse'
        },
        // States
        user() {
            return this.$store.state.shipping.notification.notification.user
        },
        docks() {
            return this.$store.state.shipping.notification.notification.docks
        },
        dockReservationStatuses() {
            return this.$store.state.shipping.notification.notification.dockReservationStatuses
        },
        availableHoursForSelectedDay() {
            return this.$store.state.shipping.notification.notification.availableHoursForSelectedDay
        },
        dockReservations() {
            return this.$store.state.shipping.notification.notification.dockReservations
        },

        // Error message
        contactNumberErrors() {
            const errors = []

            if (!this.$v.dockReservation.contactNumber.$dirty) return errors
            if (!this.$v.dockReservation.contactNumber.minLength)
                errors.push('Numer telefonu musi zawierać 12 znaków.')
            if (!this.$v.dockReservation.contactNumber.required)
                errors.push('Numer telefonu komórkowego jest wymagany.')

            return errors
        },
        trailerPlateNumberErrors() {
            const errors = []

            if (!this.$v.dockReservation.trailerPlateNumber.$dirty) return errors
            if (!this.$v.dockReservation.trailerPlateNumber.minLength)
                errors.push('Numer rejestracyjny musi zawierać minimum 3 znaki.')

            return errors
        },
        dockReservationPalletsQuantityErrors() {
            const errors = []

            if (!this.$v.dockReservation.palletsQuantity.$dirty) return errors
            if (!this.$v.dockReservation.palletsQuantity.integer || !this.$v.dockReservation.palletsQuantity.between )
                errors.push('Proszę podać prawidłową wartość z zakresu 1-50.')
            if (!this.$v.dockReservation.palletsQuantity.required)
                errors.push('Ilość palet jest wymagana.')

            return errors
        },
        carPlateNumberErrors() {
            const errors = []

            if (!this.$v.dockReservation.plateNumber.$dirty) return errors
            if (!this.$v.dockReservation.plateNumber.minLength)
                errors.push('Numer rejestracyjny musi zawierać minimum 3 znaki.')
            if (!this.$v.dockReservation.plateNumber.required)
                errors.push('Numer rejestracyjny jest wymagany.')

            return errors
        },        
        selectedDockErrors() {
            const errors = []

            if (!this.$v.dockReservation.dockId.$dirty) return errors
            if (!this.$v.dockReservation.dockId.required)
                errors.push('Wybór doku jest wymagany.')

            return errors
        },
        dockingStartDateErrors() {
            const errors = []

            if (!this.$v.dockReservation.dockingStartDateTime.$dirty) return errors
            if (!this.$v.dockReservation.dockingStartDateTime.required)
                errors.push('Data rezerwacji jest wymagana.')

            return errors
        },
        dockingStartDateTimeErrors() {
            const errors = []

            if (!this.$v.dockReservation.dockingStartDateTime.$dirty) return errors
            if (!this.$v.dockReservation.dockingStartDateTime.required)
                errors.push('Godzina rezerwacji jest wymagana.')

            return errors
        },
        customerIdErrors() {
            const errors = []

            if (!this.$v.dockReservation.customerId.$dirty) return errors
            if (!this.$v.dockReservation.customerId.required)
                errors.push('Klient jest wymagany.')

            return errors
        },
    },
    watch: {
        isOpen() {
            this.action = this.actionName

            if (this.currentDockReservation.info === null) return

            if (!this.isCreateAction) {
                this.dockReservation = JSON.parse(JSON.stringify(this.currentDockReservation.dockReservationData))
                this.customers.push(this.currentDockReservation.dockReservationData.customer)
                this.isUpdateDockReservationAction && (this.needToShowReservationSection = true)
            }
        },
        customersSearch(value = null) {
            if (value === null) return

            this.customersSearchLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchCustomers(value)
                } else {
                    this.customersSearchLoading = false
                    this.customers = []
                }
            }, 500)
        },
    },
    methods: {
        clearDate() {
            this.$store.dispatch('shipping/notification/clearAvailableHoursForSelectedDay')
            this.dockReservation.dockingStartDate = null
            this.dockReservation.dockingStartDateTime = null
        },
        searchCustomers(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie klienta')

            this.$store.dispatch('customers/getCustomers', {
                paginate: '?limit=20',
                query: `&isHidden=false&config=notifications&name=${query}`
            })
                .then(response => {
                    this.customers = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.customersSearchLoading = false
                })
        },
        updateDate(dockReservation) {
            this.$store.dispatch('customers/getCustomer', dockReservation.customerId)
                .then(response => {
                    this.customers.push(response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })

            this.dockReservation.dockingStartDate = (new Date()).toISOString().slice(0, 10)
        },
        displayHours() {
            if (this.dockReservation.dockingStartDate) {
                if (this.user.profile.customerId) {
                    return this.$store.dispatch('shipping/notification/getDockOccupation', {
                        customerId: this.user.profile.customerId,
                        date: `?start=${this.dockReservation.dockingStartDate}&end=${this.dockReservation.dockingStartDate}`,
                        dockId: this.dockReservation.dockId
                    }).then(response => {
                        store.dispatch('shipping/notification/setAvailableHoursForSelectedDay', {data: response.data, selectedDate: this.dockReservation.dockingStartDate})
                    })
                        .catch(error => {
                            errorHandler(error)
                        })
                }
                if (this.dockReservation.customerId) {
                    return this.$store.dispatch('shipping/notification/getDockOccupation', {
                        customerId: this.dockReservation.customerId,
                        date: `?start=${this.dockReservation.dockingStartDate}&end=${this.dockReservation.dockingStartDate}`,
                        dockId: this.dockReservation.dockId
                    }).then(response => {
                        store.dispatch('shipping/notification/setAvailableHoursForSelectedDay', {data: response.data, selectedDate: this.dockReservation.dockingStartDate})
                    })
                        .catch(error => {
                            errorHandler(error)
                        })
                }
            }

        },
        toClipboard() {
            this.dockReservation.inClipboard = true
            this.update(this.dockReservation)
        },
        saveNotification() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            if (this.isCreateAction) {
                if (!this.isWarehouseUser) {
                    this.dockReservation.customerId = this.user.profile.customerId
                }
                this.save(this.dockReservation)
            }
            if (this.isUpdateDockReservationAction) {
                this.update(this.dockReservation)
            }
            if (this.isUpdateClipboardReservationAction) {
                this.updateClipBoard(this.dockReservation)
            }
        },
        update(payload) {
            this.actionLoading = true
            this.$store.dispatch('shipping/notification/updateNotification', payload)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(this.onClose)
        },
        updateClipBoard(payload) {
            this.actionLoading = true
            this.$store.dispatch('shipping/notification/updateClipboardNotification', payload)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(this.onClose())
        },
        save(payload) {
            this.actionLoading = true
            this.$store.dispatch('shipping/notification/saveNotification', payload)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(this.onClose())
        },
        onClose() {
            this.actionLoading = false
            this.$emit('close-notification-dialog')
            this.$store.dispatch('shipping/notification/clearAvailableHoursForSelectedDay')
            this.$store.dispatch('shipping/notification/clearBusinessHours')
            this.$v.$reset()
            setTimeout(() => {
                this.dockReservation = {}
                this.customers = []
            }, 500)
        },
        setAvailableHours(value) {
            return format(new Date(value), 'HH:mm')
        },
        setReservationDate(start, end) {
            return `${format(new Date(start), 'YYYY-MM-DD')}, ${format(new Date(start), 'HH:mm')} - ${format(new Date(end), 'HH:mm')}`
        },
    },
}

</script>

